var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteChevron({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "6px",
    viewBox: "0 0 9 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mask") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    transform: "translate(0.166667, 0.166666)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.08088075,0.181394512 C0.827237356,-0.0668174585 0.423338804,-0.0593701685 0.178748084,0.198028502 C-0.0658426358,0.455427172 -0.0585039958,0.865305582 0.195139394,1.11351754 L4.16666666,5 L8.13819393,1.11351754 C8.39183732,0.865305582 8.39917596,0.455427172 8.15458524,0.198028502 C7.90999452,-0.0593701685 7.50609597,-0.0668174585 7.25245257,0.181394512 L4.16666666,3.20110254 L1.08088075,0.181394512 Z",
    id: "path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteChevron);
export default __webpack_public_path__ + "static/media/white-chevron.1fee6d7ecf509535da6cf67438535679.svg";
export { ForwardRef as ReactComponent };